import styles from './styles.module.scss';
import { Props } from './types';

const InputRange = ({
  smallInput,
  minValue,
  maxValue,
  minValueKey,
  maxValueKey,
  minValueOptions,
  maxValueOptions,
  minPlaceholder,
  maxPlaceholder,
  onChange,
  disabled,
}: Props) => {
  // TODO: Handle max value lower than min value and vice versa

  return (
    <div className={styles.container}>
      <input
        disabled={disabled}
        className={
          smallInput
            ? [styles.input, styles.smallInput].join(' ')
            : styles.input
        }
        id={minValueKey}
        type="text"
        list={`${minValueKey}List`}
        value={minValue}
        onChange={onChange}
        placeholder={minPlaceholder}
      />
      {minValueOptions && (
        <datalist id={`${minValueKey}List`}>
          {minValueOptions.map(option => (
            <option key={option}>{option}</option>
          ))}
        </datalist>
      )}
      <span className={styles.separator}>-</span>
      <input
        disabled={disabled}
        className={
          smallInput
            ? [styles.input, styles.smallInput].join(' ')
            : styles.input
        }
        id={maxValueKey}
        type="text"
        list={`${maxValueKey}List`}
        value={maxValue}
        onChange={onChange}
        placeholder={maxPlaceholder}
      />
      {maxValueOptions && (
        <datalist id={`${maxValueKey}List`}>
          {maxValueOptions.map(option => (
            <option key={option}>{option}</option>
          ))}
        </datalist>
      )}
    </div>
  );
};

export default InputRange;
